import React from 'react';
import PropTypes from 'prop-types';
import { TileGridWrapper, TileWrapper } from './styles';
import Tile from './tile';
import { propLink } from '../link-handler';
import { ButtonColorProps } from '../../prop-types';
import RichText from '../rich-text/base';
import { useLayout } from '../layout/context';

const TileGrid = ({ heading, shortDescription, tiles, maxColumns = 3 }) => {
  const { insideTwoThirds, insideHalfWidth, insideSideBar } = useLayout();
  const narrowContainer = insideTwoThirds || insideHalfWidth;

  if (!tiles) return null;
  return (
    <TileGridWrapper
      $narrowContainer={narrowContainer}
      $insideSideBar={insideSideBar}
    >
      {heading ? <h2>{heading}</h2> : null}
      {shortDescription ? <RichText richText={shortDescription} /> : null}
      <TileWrapper
        $narrowContainer={narrowContainer}
        $insideSideBar={insideSideBar}
        $maxColumns={maxColumns}
      >
        {tiles.map(({ text, link, tileColor }, i) => (
          <Tile
            text={text}
            link={link}
            tileColor={tileColor}
            dataTracking={`tile-${i + 1}`}
            key={i}
          />
        ))}
      </TileWrapper>
    </TileGridWrapper>
  );
};

TileGrid.propTypes = {
  heading: PropTypes.string,
  shortDescription: PropTypes.object,
  tiles: PropTypes.arrayOf(
    PropTypes.shape({
      itemText: PropTypes.string,
      link: propLink,
      tileColor: ButtonColorProps,
    })
  ),
  maxColumns: PropTypes.number,
};

export default TileGrid;

export const TileGridAssembly = ({ contentfulData }) => (
  <TileGrid
    heading={contentfulData.heading}
    shortDescription={contentfulData.shortDescription}
    tiles={contentfulData.tiles}
  />
);

TileGridAssembly.propTypes = {
  contentfulData: PropTypes.object,
};
